import { useState } from "react"
import bot from '../../assets/images/happy.png';
import LastMenu from "./LastMenu";

const ExecutiveEdu = () =>{
    
        const [time] = useState(new Date());
    return(
        <>
            <div className='chatbot'>
            <img src={bot} alt="bot" className="bot" />
            <div className='chatbot-time'>{time.toLocaleTimeString()}</div>
            </div>
            <div className="frame1 animated-frame">
            We offer more than 60 executive development programs 
            taught by full-time Harvard Business School faculty. Participants
             typically have 10 years or more of professional work experience 
             and are sponsored by their current employers. Use our program finder
              to search topics and view upcoming programs.
            <br></br><br></br>
            If you are interested in a degree program, please visit the
            <a href="https://www.harvard.edu" target="_blank" rel="noopener noreferrer"> Harvard University website</a>.
            </div>
            <LastMenu id={1} />
        </>
    );
}
export default ExecutiveEdu;